<template>
  <div class="container p-0" style="background:white;">
    <BannerCarousel
      :bannerImgUrl="[
      '/images/banner_1.png',
    ]"
      :route="['/occasion/christmas']"
    />

    <ProductShowcase route="/theme/balloons" title="Popular Products" />

    <FeatureBanner
      :bannersNum="4"
      :route="['/' , '/' , '/' , '/']"
      :bannerImgUrl="[
            'https://k.nooncdn.com/cms/pages/20200325/9dfc41a31407cd208af0ba5ccd827821/en_mb-cat-module-menswatches.jpg',
            'https://k.nooncdn.com/cms/pages/20200325/9dfc41a31407cd208af0ba5ccd827821/en_mb-cat-module-menseyewear.jpg',
            'https://k.nooncdn.com/cms/pages/20200325/9dfc41a31407cd208af0ba5ccd827821/en_mb-cat-module-menseyewear.jpg',
            'https://k.nooncdn.com/cms/pages/20200325/9dfc41a31407cd208af0ba5ccd827821/en_mb-cat-module-womenseyewear.jpg'
        ]"
    />

    <FeatureBanner
      :bannersNum="1"
      :bannerImgUrl="['/images/banner_2.png']"
      :route="['/occasion/new-year']"
    />
    <div style="padding: 20px;padding-top:0;display:none;">
      <FeatureBanner
        :bannersNum="6"
        :route="['/' , '/' , '/' , '/' , '/' , '/']"
        :title="['Newer Clothes' , 'Baby' , 'Land' , 'Baby V2' , 'Baby V4' , 'Baby V5']"
        :bannerImgUrl="[
            'https://k.nooncdn.com/cms/pages/20200809/2c7d1986f653a084f2697f419603d3f9/en_cat-module-01.jpg',
            'https://k.nooncdn.com/cms/pages/20200809/2c7d1986f653a084f2697f419603d3f9/en_cat-module-05.jpg',
            'https://k.nooncdn.com/cms/pages/20200809/2c7d1986f653a084f2697f419603d3f9/en_cat-module-10.jpg',
            'https://k.nooncdn.com/cms/pages/20200809/2c7d1986f653a084f2697f419603d3f9/en_cat-module-10.jpg',
            'https://k.nooncdn.com/cms/pages/20200809/2c7d1986f653a084f2697f419603d3f9/en_cat-module-10.jpg',
            'https://k.nooncdn.com/cms/pages/20200809/2c7d1986f653a084f2697f419603d3f9/en_cat-module-10.jpg'
        ]"
      />
    </div>
  </div>
</template>

<script>
import FeatureBanner from "../components/landing-components/FeatureBanner.vue";
import BannerCarousel from "../components/landing-components/BannerCarousel.vue";
import ProductShowcase from "../components/landing-components/ProductShowcase.vue";

export default {
  components: {
    FeatureBanner,
    BannerCarousel,
    ProductShowcase,
  },
};
</script>

<style>
</style>